<template>
  <div style="overflow-y: auto; height: 90vh;">

    <div style="width: 98%; margin-top: 20px; text-align: end; color: #409eff; font-size: 20px;">
      <el-tooltip class="item" effect="light" content="返回 -> 签约方案(新)列表" placement="right-start">
        <el-button @click="handleToRetnrn" plain size="mini" type="primary" icon="el-icon-mouse">返回</el-button>
      </el-tooltip>
    </div>

    <div style="width: 100%;">
      <el-divider></el-divider>
    </div>

    <div style="display: flex; margin-bottom: 20px;width: 100%;margin-left: 10px; justify-content: space-between;">
       
      
      <div style="display: flex">
         <div style="display: flex">
            <div style="width: 100px;padding-top: 10px;margin-right: 10px;">方案名称:</div>
            <el-input style="width: 350px;" v-model="inputName" :disabled="isShowAddSigningPlanForbidden" placeholder="请输入方案名称"></el-input>
          </div>

          <div style="display: flex">
            <div style="width: 100px;padding-top: 10px;margin-right: 10px;">课程类别:</div>
            <el-select placeholder="请选择方案" v-model="planNamesss1" clearable @change="seleValue">
              <el-option v-for="(item, index) in planNamesss" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
      </div>
        

        <div style=" margin-top: 5px; width: 12%;">
          <el-button @click="handleEdit1" :disabled="isShowAddSigningPlanForbidden" plain size="mini" type="primary" icon="el-icon-mouse">添加方案</el-button>
        </div>
    </div>

    <div v-for="(itme,index) in tableData" :key="index" style="margin-bottom: 80px;">

      <div style="width: 98%; margin-left: 5px;display: flex; border: 1px solid #bdb9b9;padding: 0px;">
        <div style="width: 10%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">业务类别</div>
        <div style="width: 10%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">项目</div>
        <div style="width: 10%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">上课方式</div>
        <div style="width: 10%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">单价</div>
        <div style="width: 10%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">课时倍数</div>
        <div style="width: 15%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">有效期</div>
        <div style="width: 10%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">备注</div>
        <!-- <div style="width: 10%;padding: 0px;border-right: 1px solid #bdb9b9;padding-top: 10px;padding-bottom: 10px;">修改历史记录</div> -->
        <div style="width: 25%;padding: 0px;padding-top: 10px;padding-bottom: 10px;">操作</div>
      </div>

      <div style="width: 98%;  margin-left: 5px; display: flex; border-left: 1px solid rgb(189, 185, 185);  border-bottom: 1px solid rgb(189, 185, 185);  padding: 0px;   border-right: 1px solid rgb(189, 185, 185); ">
          <el-tooltip class="item" effect="light" :content="itme.classBusinessName" placement="right-start">
            <div class="single-line" style="width: 9.95%;padding: 0px;border-right: 1px solid #bdb9b9;justify-content: center;align-items: center; display: flex;">{{itme.classBusinessName}}</div>
          </el-tooltip>
          <div style="width: 85%;">
            <div style="width: 100%; display: flex;" v-for="(itmes,indexs) in itme.signContractInfoList" :key="indexs" class="bottnmBorder">
              <el-tooltip class="item" effect="light" :content="itmes.projectName" placement="right-start">
                <div class="single-line" style="width: 11.7%;padding: 10px 0px;border-right: 1px solid #bdb9b9;" :style="{ borderBottom: indexs < itme.signContractInfoList.length - 1 ? '1px solid #bdb9b9' : '' }">{{itmes.projectName}} </div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" :content="itmes.classTypeName" placement="left-start">
                <div class="single-line" style="width: 11.75%;padding: 10px 0px;border-right: 1px solid #bdb9b9;" :style="{ borderBottom: indexs < itme.signContractInfoList.length - 1 ? '1px solid #bdb9b9' : '' }">{{itmes.classTypeName}}</div>
              </el-tooltip>
              <!-- <el-tooltip class="item" effect="light"  placement="left-start"> -->
                <div class="single-line" style="width: 11.68%;padding: 10px 0px;border-right: 1px solid #bdb9b9;" :style="{ borderBottom: indexs < itme.signContractInfoList.length - 1 ? '1px solid #bdb9b9' : '' }">{{itmes.unitPrice}}</div>
              <!-- </el-tooltip> -->
              <!-- <el-tooltip class="item" effect="light"  placement="left-start"> -->
                <div class="single-line" style="width: 11.68%;padding: 10px 0px;border-right: 1px solid #bdb9b9;" :style="{ borderBottom: indexs < itme.signContractInfoList.length - 1 ? '1px solid #bdb9b9' : '' }">{{itmes.hourMultiple}}</div>
              <!-- </el-tooltip> -->
              <el-tooltip class="item" effect="light" :content="itmes.periodStartDate + '  -  ' + itmes.periodEndDate" placement="left">
                <div class="single-line" style="width: 17.55%;padding: 10px 0px;border-right: 1px solid #bdb9b9;" :style="{ borderBottom: indexs < itme.signContractInfoList.length - 1 ? '1px solid #bdb9b9' : '' }">{{itmes.periodStartDate}} - {{itmes.periodEndDate}}</div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" :content="itmes.remark ? itmes.remark : '暂无备注~'" placement="right">
                <div class="single-line" style="width: 11.7%;padding: 10px 0px;border-right: 1px solid #bdb9b9;" :style="{ borderBottom: indexs < itme.signContractInfoList.length - 1 ? '1px solid #bdb9b9' : '' }">{{itmes.remark}}</div>
              </el-tooltip>
              <!-- <el-tooltip class="item" effect="light" content="查看历史" placement="right">
                <div class="single-line" style="width: 11.7%;padding: 10px 0px;border-right: 1px solid #bdb9b9;color: #409eff;" :style="{ borderBottom: indexs < itme.signContractInfoList.length - 1 ? '1px solid #bdb9b9' : '' }">查看历史</div>
              </el-tooltip> -->
              <div style="width: 21.7%;padding: 10px 0px;display: flex; justify-content: end;">
                  <span style="color: #409eff;padding-right: 5px;" @click="handleDelet(itmes,indexs)" :class="isShowAddSigningPlanForbidden ? 'is-disabled' : '' ">删除</span>
                  <span style="color: #409eff;padding-right: 5px;padding-left: 5px;" @click="handleEdit(itmes,indexs,index)" :class="isShowAddSigningPlanForbidden ? 'is-disabled' : '' ">编辑</span>
                  <span style="color: #409eff;padding-left: 5px;" @click="handleView(itmes,indexs)">查看历史</span>
              </div>
            </div>
          </div>

      </div>
      <el-tooltip class="item" effect="light" content="新增" placement="bottom">
        <div style="padding: 10px 0px;width: 98%; justify-content: center;  margin-left: 5px;   display: flex;  border-left: 1px solid rgb(189, 185, 185);  border-bottom: 1px solid rgb(189, 185, 185);  padding: 0px;   border-right: 1px solid rgb(189, 185, 185);  ">
            <span style="color: #409eff;padding: 5px 0px;" @click="handleAdd(itme.signContractInfoList,index)" :class="isShowAddSigningPlanForbidden ? 'is-disabled' : '' ">新增</span>
        </div>
      </el-tooltip>
    </div>

    <div v-if="tableData.length < 1" style="width: 100%; height: 500px;border: 1px solid #dcdfe6;display: flex;justify-content: center; align-items: center;">
      <span>暂无数据</span>
    </div>

    <el-dialog :visible="dialogVisible" odal-append-to-body append-to-body :close-on-click-modal="false" :before-close="showDomgcloseEditDialog" width="60%">

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">业务类别:</div>
        <el-select placeholder="请选择业务类别" :disabled="isAddType === '新增'"  v-model="input" style="width: 100%" clearable filterable @change="handleChange">
          <el-option v-for="(item,index) in optionList5" :key="index" :value="item.id" :label="item.categoryName"></el-option>
        </el-select>
      </div>


      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">项目:</div>
        <el-select placeholder="请选择项目" v-model="input1" :disabled="isShowSelect" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.categoryName"></el-option>
        </el-select>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">上课方式:</div>
        <el-select placeholder="请选择上课方式" v-model="input6"  style="width: 100%" clearable filterable multiple>
          <el-option v-for="item in optionList4" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">单价:</div>
        <el-input-number style="width: 100%;" v-model="input2" :min="0" :max="99999999" ></el-input-number>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">课时倍数:</div>
        <el-input-number v-model="input5" :precision="2" :step="0.1" :max="100"></el-input-number>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">有效期:</div>
        <el-date-picker style="width: 100%;" v-model="input3" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable> </el-date-picker>
      </div>

      <div style="display: flex; margin-bottom: 40px;">
        <div style="width: 80px;padding-top: 10px;">备注:</div>
        <el-input style="width: 100%;" type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" maxlength="300" show-word-limit  v-model="input4"></el-input>
      </div>


      <div style="display: flex; margin-bottom: 20px; justify-content: center;">
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('关闭')">关闭</el-button>
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('保存')">保存</el-button>
      </div>

    </el-dialog>



    <el-dialog :visible="dialogVisible1" title="历史记录" odal-append-to-body append-to-body :close-on-click-modal="false" :before-close="showDomgcloseEditDialog1" width="60%">

      <div style="margin-bottom: 20px; overflow-y: auto; height: 400px;" v-for="(itme,index) in sign_contract_log" :key="index">
        <div style="margin-bottom: 20px;padding: 10px;border: 1px solid #c9c3c3;">

          <div style="margin-bottom: 20px;">
            <div style="margin-left:10px;margin-bottom: 10px;">项目名称：{{ itme.projectName}} </div>
            <div style="margin-left:10px;margin-bottom: 10px;">修改前单价：{{ itme.unitPrice}} </div>
            <div style="margin-left:10px;margin-bottom: 10px;">修改后单价：{{ itme.unitPriceUpdate}}</div>
            <div style="margin-left:10px;margin-bottom: 10px;">修改人 ：{{ itme.updateName}}</div>
            <div style="margin-left:10px;margin-bottom: 10px;">修改时间 ：{{ itme.createTime}}</div>
            <div style="margin-left:10px;margin-bottom: 10px;">备注 ：{{ itme.remark}}</div>
          </div>

        </div>
      </div>

      <div style="display: flex; margin-bottom: 20px; justify-content: center;">
        <el-button  type="primary" size="small" class="btns"  @click="handleClickViewBtn('关闭')">关闭</el-button>
      </div>

    </el-dialog>



    <div style="width: 98%; margin-top: 20px; text-align: end; color: #409eff; font-size: 20px; position: absolute; bottom: 40px;">
      <div style="width: 100%;">
        <el-divider></el-divider>
      </div>
      <el-tooltip class="item" effect="light" content="保存方案 √ " placement="right-start">
        <el-button @click="handleAddSubmit" :disabled="isShowAddSigningPlanForbidden"  plain size="mini" type="primary" icon="el-icon-check">保存</el-button>
      </el-tooltip>
    </div>



  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
export default {
  props: {
    isShowAddSigningPlanForbidden: {
      type: Boolean,
      default: false,
    },
    isShowAddSigningPlanID: {
      type: Number,
    },
    isAdd: {
      type: Number,
      default: 1,
    },
    typeNode: {
      type: String,
      default: '',
    },
  },
  data () {
    return {

      planNamesss:[
        { id:1, name: '学业课' },
        { id:2, name: '家庭教育课' },
      ],

      planNamesss1:'',

      inputName: '',
      input: '',
      input1: '',
      input2: 0,
      input3: [],
      input4: '',
      input5: 1,
      input6: [],
      optionList4: [{ id: 1, name: '网课' }, { id: 2, name: '上门' }, { id: 3, name: '门店' }],
      optionList3: [],
      optionList5: [],
      dialogVisible: false,
      dialogVisible1: false,
      isShowSelect: true,
      tableData:[],
      nodeindex: 0,
      sign_contract_log:[],
      isAddType:'添加',
      Editindex:0,
      inputNameid:'',
      itmeID:'',
    }
  },
  mounted () {
    this.handleGetsign_category()


    if(this.isShowAddSigningPlanID){
      this.handleGetsign_contract()
    }
  },
  methods: {

    handleGetsign_scheduleCategoryChildren(id){
      axios.get(`${apiBaseUrl}/schedule/categoryChildren/${id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
         if(res.data.code === 200){
            if(res.data.data && res.data.data.length > 0){
              this.optionList3 = res.data.data
            }else{
              this.optionList3 = []
            }
         }else{
           this.optionList3 = []
           this.$message.error(res.data.message)
         }
        }).catch(error => {
          this.$message.error(error)
      })
    },

    handleGetsign_category(){
      axios.get(`${apiBaseUrl}/category/one`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
         if(res.data.code === 200){
            if(res.data.data && res.data.data.length > 0){
              this.optionList5 = res.data.data
            }else{
              this.optionList5 = []
            }
         }else{
           this.optionList5 = []
           this.$message.error(res.data.message)
         }
        }).catch(error => {
          this.$message.error(error)
      })
    },

    handleGetsign_contract(){
      axios.get(`${apiBaseUrl}/sign_contract/findById/${this.isShowAddSigningPlanID}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
         if(res.data.code === 200){
            this.$message.success(res.data.message)

            this.inputName = res.data.data.signContractName
            this.inputNameid = res.data.data.id
            this.planNamesss1 = res.data.data.categoryType

            if(res.data.data && res.data.data.classBusinessList.length > 0){
               this.tableData = res.data.data.classBusinessList
            }else{
              this.tableData = []
            }
         }else{
           this.tableData = []
           this.$message.error(res.data.message)
         }
        }).catch(error => {
          this.$message.error(error)
      })
    },


    handleChange(e){
      this.isShowSelect = false
      this.input1 = ''
      this.handleGetsign_scheduleCategoryChildren(e)
    },


    handleLogic(){
      this.optionList5.map((itme)=>{
          if(itme.id === Number(this.input) || itme.id === String(this.input)){
            this.tableData[this.nodeindex].classBusinessName = itme.categoryName
            this.tableData[this.nodeindex].classBusinessId = itme.id
          }
      })
    },
    handleClickViewBtn (type) {
      if (type === '关闭') {
          this.input = ''
          this.input1 = ''
          this.input2 = 0
          this.input3 = []
          this.input4 = ''
          this.input6 = []
          this.dialogVisible = false
          this.dialogVisible1 = false
      }

      if (type === '保存') {


          if(this.input === '' && this.input1 == '' && this.input6.length < 1){
            this.$message.warning('请选择（业务类别）, (项目), (上课方式), (有效期) ...')
          }else{
            if(this.isAddType === '添加'){
               this.handleaAdd_edit_newlyAdded()
            }

            if(this.isAddType === '編輯'){
               this.handleaEdit_add_newlyAdded()
            }

            if(this.isAddType === '新增'){
               this.handleaNewlyAdded_edit_add()
            }

          }

      }

    },

    handleaNewlyAdded_edit_add(){
      let categoryName = ''
        this.optionList3.map((itme)=>{
            if(itme.id === Number(this.input1) || itme.id === String(this.input1)){
              categoryName = itme.categoryName
            }
        })

        let matchedNames = []
        this.optionList4.map((itme)=>{
          this.input6.map((itmes)=>{
            if(itmes === itme.id){
              matchedNames.push(itme.name)
            }
          })
        })

        let obj = {
          classBusinessId: this.input,
          projectId: this.input1,
          projectName: categoryName,
          unitPrice: this.input2,
          periodStartDate: this.input3.length > 0 ? this.input3[0] : null,
          periodEndDate: this.input3.length > 0 ? this.input3[1] : null,
          remark: this.input4,
          hourMultiple: this.input5,
          classType: this.input6.length > 0 ? this.input6.join(',') : null,
          classTypeName: matchedNames.join(','),
        }

        if (!this.tableData[this.nodeindex]) {
            this.tableData[this.nodeindex] = {}
        }

        if (!Array.isArray(this.tableData[this.nodeindex].signContractInfoList)) {
            this.tableData[this.nodeindex].signContractInfoList = []
        }



        this.tableData[this.nodeindex].signContractInfoList.push(obj)
        this.handleLogic()


        this.input = ''
        this.input1 = ''
        this.input2 = 0
        this.input3 = []
        this.input4 = ''
        this.input5 = 1
        this.input6 = []
        this.dialogVisible = false
    },

    handleaEdit_add_newlyAdded(){

      let categoryName = ''
        this.optionList3.map((itme)=>{
            if(itme.id === Number(this.input1) || itme.id === String(this.input1)){
              categoryName = itme.categoryName
            }
        })

        let matchedNames = []
        this.optionList4.map((itme)=>{
          this.input6.map((itmes)=>{
            if(itmes === itme.id){
              matchedNames.push(itme.name)
            }
          })
        })

        let obj = {
          classBusinessId: this.input,
          projectId: this.input1,
          projectName: categoryName,
          unitPrice: this.input2,
          periodStartDate: this.input3.length > 0 ? this.input3[0] : null,
          periodEndDate: this.input3.length > 0 ? this.input3[1] : null,
          remark: this.input4,
          hourMultiple: this.input5,
          classType: this.input6.length > 0 ? this.input6.join(',') : null,
          classTypeName: matchedNames.join(','),
          id: this.itmeID ? this.itmeID : ''
        }

        this.tableData[this.nodeindex].signContractInfoList[this.Editindex] = obj
        this.handleLogic()


        this.input = ''
        this.input1 = ''
        this.input2 = 0
        this.input3 = []
        this.input4 = ''
        this.input5 = 1
        this.input6 = []

        this.dialogVisible = false

    },

    handleaAdd_edit_newlyAdded(){
        let categoryName = ''
        this.optionList3.map((itme)=>{
            if(itme.id === Number(this.input1) || itme.id === String(this.input1)){
              categoryName = itme.categoryName
            }
        })

        let matchedNames = []
        this.optionList4.map((itme)=>{
          this.input6.map((itmes)=>{
            if(itmes === itme.id){
              matchedNames.push(itme.name)
            }
          })
        })

        let obj = {
          classBusinessId: this.input,
          projectId: this.input1,
          projectName: categoryName,
          unitPrice: this.input2,
          periodStartDate: this.input3.length > 0 ? this.input3[0] : null,
          periodEndDate: this.input3.length > 0 ? this.input3[1] : null,
          remark: this.input4,
          hourMultiple: this.input5,
          classType: this.input6.length > 0 ? this.input6.join(',') : null,
          classTypeName: matchedNames.join(','),
        }


        if (this.tableData.length === 0) {
          if (!this.tableData[0]) {
            this.tableData[0] = {}
          }

          if (!Array.isArray(this.tableData[0].signContractInfoList)) {
            this.tableData[0].signContractInfoList = []
          }

          this.nodeindex = 0
          this.tableData[0].signContractInfoList.push(obj)
          this.handleLogic()
        } else {
          this.tableData.push({ signContractInfoList: [] })
          this.tableData[this.tableData.length - 1].signContractInfoList.push(obj)
          this.nodeindex = this.tableData.length - 1
          this.handleLogic()
        }

        this.input = ''
        this.input1 = ''
        this.input2 = 0
        this.input3 = []
        this.input4 = ''
        this.input5 = 1
        this.input6 = []
        this.dialogVisible = false
    },

    handleAddSubmit(){


        if(this.inputName === ''){
          this.$message.warning('请填写方案名称~')
          return
        }

        let isUrl = ''
        let obj = { signContractName: '',  List: [], }

        if(this.isAdd  === 1){
            isUrl = 'sign_contract/add'
            obj = {  signContractName: this.inputName, classBusinessList: this.tableData,  categoryType: this.planNamesss1, }
        }

        if(this.isAdd  === 2){
            isUrl = 'sign_contract/update'
            obj = {  signContractName: this.inputName, classBusinessList: this.tableData, id: this.inputNameid , categoryType: this.planNamesss1, }
        }

        axios.post(`${apiBaseUrl}/` + isUrl, obj,{ headers :{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
            if(res.data.code === 200){
              this.$message.success(res.data.message)
              this.$emit('handleToRetnrn',false)
            }else{
              this.$message.error(res.data.message)
            }
          }).catch(error => {
            console.error(error)
            this.$message.error(error)
        })

    },

    handleToRetnrn(){
      this.$emit('handleToRetnrn',false)
    },

    showDomgcloseEditDialog () {
      this.dialogVisible = false
    },

    showDomgcloseEditDialog1 () {
      this.dialogVisible1 = false
    },
    handleDelet (itme) {

      this.$confirm('你确定要删除当前项吗?', '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',  type: 'warning'   }).then(() => {

      if(itme.id){
           axios.post(`${apiBaseUrl}/sign_contract/deleteInfoById/${itme.id}`,{},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
                if (res.data.code == 200) {
                  this.handleGetsign_contract()
                } else {
                  this.$message.error(res.data.message)
                }
            }).catch(error => {
              this.$message.error(error)
            })
      }else{
        this.$message.warning('占无id...')
      }
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
      })


    },
    handleEdit1 () {
      this.input = ''
      this.input1 = ''
      this.input2 = 0
      this.input3 = []
      this.input4 = ''
      this.input5 = 1
      this.input6 = []
      this.isAddType = '添加'
      this.dialogVisible = true

    },
    handleEdit (itme,index,indexs) {

      this.handleGetsign_scheduleCategoryChildren(itme.classBusinessId)

      this.isAddType = '編輯'
      this.dialogVisible = true
      this.Editindex = index
      this.nodeindex = indexs
      this.input = itme.classBusinessId
      this.input1 = itme.projectId
      this.input6 = itme.classType.split(',').map(Number)
      this.input2 = itme.unitPrice
      this.input5 = itme.hourMultiple
      this.input3 = [itme.periodStartDate,itme.periodEndDate]
      this.input4 = itme.remark
      this.itmeID = itme.id

      console.log(itme)

      if(itme.classBusinessId){
        this.isShowSelect = false
      }else{
        this.isShowSelect = true
      }

    },
    handleView (itme) {

      axios.post(`${apiBaseUrl}/sign_contract_log/findPage/${itme.id}`,{pageNum:1, pageSize:10000},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.sign_contract_log = res.data.data.records
            } else {
              this.$message.error(res.data.message)
            }
        }).catch(error => {
          this.$message.error(error)
      })

      this.dialogVisible1 = true
    },
    handleAdd (itmeList,index) {
      this.isAddType = '新增'
      this.nodeindex = index
      this.dialogVisible = true

      this.input = itmeList[0].classBusinessId

      if(this.input){
         this.isShowSelect = false
         this.handleGetsign_scheduleCategoryChildren(this.input)
      }

    },


  }
}
</script>

<style scoped>

.text {
  display: inline-block;
  font-size: 22px;
  border: 1px solid #ccc;
  width: 50px;
  height: 38px;
  border-radius: 5px;
}

@media screen and (max-width: 750px) {
  .ContractPlan {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  .ContractPlan>>>.el-dialog {
    width: 100% !important;
  }

  /* .ContractPlan>.el-dialog>>>.el-dialog {
    width: 100% !important;
  } */
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

.is-disabled{
  pointer-events: none;
}


.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/NewSigningPlanFiles/AddSigningPlan.vue